import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function RequestContactDialog({ open, onOpenChange, member }) {
  const [form, setForm] = useState({ requester_name: "", requester_email: "", requester_phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const change = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!member) return;
    setSubmitting(true);
    try {
      await api.post("/contact-requests", { member_id: member.id, ...form });
      toast.success("Request sent. The admin will review and connect you shortly.");
      onOpenChange(false);
      setForm({ requester_name: "", requester_email: "", requester_phone: "", message: "" });
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-white rounded-2xl">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">
            Request contact with {member?.name || member?.full_name || "Member"}
          </DialogTitle>
          <DialogDescription className="text-ink-soft">
            To protect member privacy, our admin will verify your request and share contact details if appropriate.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2" data-testid="contact-request-form">
          <input
            className="input-premium"
            placeholder="Your full name"
            required
            value={form.requester_name}
            onChange={change("requester_name")}
            data-testid="contact-request-name-input"
          />
          <input
            className="input-premium"
            placeholder="Your email"
            type="email"
            required
            value={form.requester_email}
            onChange={change("requester_email")}
            data-testid="contact-request-email-input"
          />
          <input
            className="input-premium"
            placeholder="Your phone (optional)"
            value={form.requester_phone}
            onChange={change("requester_phone")}
            data-testid="contact-request-phone-input"
          />
          <textarea
            className="input-premium min-h-[110px]"
            placeholder="Why would you like to connect?"
            required
            value={form.message}
            onChange={change("message")}
            data-testid="contact-request-message-input"
          />
          <button
            type="submit"
            disabled={submitting}
            className="btn-primary w-full"
            data-testid="contact-request-submit-btn"
          >
            {submitting ? <><Loader2 className="w-4 h-4 animate-spin" /> Sending…</> : "Send request"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
